(function () {
  function initScrollVideoPlay() {
    const sections = document.querySelectorAll('.banner-video-section');

    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          const video = entry.target.querySelector('video');
          if (!video) return;

          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            video.muted = true;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      {
        root: null,
        threshold: 0.5
      }
    );

    sections.forEach(section => observer.observe(section));
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', initScrollVideoPlay);

  // IMPORTANT: re-init after Load More / AJAX
  document.addEventListener('shopify:section:load', initScrollVideoPlay);

  // Optional: If you use custom Load More
  document.addEventListener('collections-loaded', initScrollVideoPlay);

})();


function isFilterActive() {
  const params = new URLSearchParams(window.location.search);

  for (const key of params.keys()) {
    if (key.startsWith('filter.') || key === 'sort_by') {
      return true;
    }
  }
  return false;
}

function toggleFilterClassByURL() {
  const grid = document.querySelector('#product-grid');
  if (!grid) return;

  if (isFilterActive()) {
    grid.classList.add('active_filter');
  } else {
    grid.classList.remove('active_filter');
  }
}

// Initial load
document.addEventListener('DOMContentLoaded', toggleFilterClassByURL);

// Shopify Facet AJAX reload (Dawn / OS 2.0)
document.addEventListener('facet:updated', toggleFilterClassByURL);



$(document).ready(function () {  

  // New splide slider
if (document.querySelector('.splide_1')) {
  const splide = new Splide(".splide_1", {
      start: 1,
      autoWidth: true,
      perMove: 3,
      gap: 8,
      type: "loop",
      drag: "free",
      snap: false,
      interval: 3000,
      arrows: true,
      pagination: true,
      rewind: true,
      rewindByDrag: true,
      lazyLoad: true,
      breakpoints: {
          768: {
              autoWidth: true,
              snap: true
          }
      }
  });
  splide.mount();
}
// if (document.querySelector('.video-splide')) {
//   // Video splide slider
//   const video_splide = new Splide(".video-splide", {
//       start: 1,
//       autoWidth: true,
//       perMove: 3,
//       gap: 8,
//       type: "loop",
//       drag: "free",
//       snap: false,
//       interval: 3000,
//       arrows: true,
//       pagination: true,
//       rewind: true,
//       rewindByDrag: true,
//       lazyLoad: true,
//       breakpoints: {
//           768: {
//               autoWidth: true,
//               snap: true
//           }
//       }
//   });
//   video_splide.mount();
//  video_splide.on('dragging', function () {
//   // Pause all videos while dragging
//   video_splide.root.querySelectorAll('video').forEach(video => {
//     video.pause();
//   });
// });

// video_splide.on('dragged moved', function () {
//   // Play only active + visible slide video
//   setTimeout(function(){
//     video_splide.root.querySelectorAll('.splide__slide').forEach(slide => {
//       const video = slide.querySelector('video');
//       if (!video) return;

//       const isActive =
//         slide.classList.contains('is-active') &&
//         slide.classList.contains('is-visible');

//       if (isActive) {
//         video.muted = true;
//         video.playsInline = true;
//         video.play().catch(() => {});
//       } else {
//         video.pause();
//         video.currentTime = 0;
//       }
//     });
//   },1000);
// });

// const isMobileOrTablet = () => window.matchMedia('(max-width: 1024px)').matches;
// function handleVideos(splide) {
//   if (!isMobileOrTablet()) return; // ⛔ desktop exits early

//   splide.root.querySelectorAll('.splide__slide').forEach(slide => {
//     const video = slide.querySelector('video');
//     if (!video) return;

//     const isActive =
//       slide.classList.contains('is-active') &&
//       slide.classList.contains('is-visible');

//     if (isActive) {
//       video.muted = true;
//       video.playsInline = true;

//       if (video.paused) {
//         video.play().catch(() => {});
//       }
//     } else {
//       video.pause();
//       video.currentTime = 0;
//     }
//   });
// }
// video_splide.on('mounted', () => {
//   handleVideos(video_splide);
// });

// video_splide.on('moved', () => {
//   handleVideos(video_splide);
// });
// window.addEventListener('resize', () => {
//   if (!isMobileOrTablet()) {
//     // Stop & reset all videos when leaving mobile/tablet
//     video_splide.root.querySelectorAll('video').forEach(video => {
//       video.pause();
//       video.currentTime = 0;
//     });
//   } else {
//     handleVideos(video_splide);
//   }
// });
// window.addEventListener('load', () => {
//   if (!isMobileOrTablet()) {
//     // Stop & reset all videos when leaving mobile/tablet
//     video_splide.root.querySelectorAll('video').forEach(video => {
//       video.pause();
//       video.currentTime = 0;
//     });
//   } else {
//     handleVideos(video_splide);
//   }
// });


// }
if (document.querySelector('.video-splide')) {
  // Video splide slider
  const video_splide = new Splide(".video-splide", {
      start: 1,
      autoWidth: true,
      perMove: 1,
      gap: 8,
      type: "loop",
      drag: "free",
      snap: false,
      interval: 3000,
      arrows: true,
      pagination: true,
      rewind: true,
      rewindByDrag: true,
      lazyLoad: true,
      breakpoints: {
          768: {
              autoWidth: true,
              snap: true
          }
      }
  });
  video_splide.mount();

  const isMobileOrTablet = () => window.matchMedia('(max-width: 1024px)').matches;

  video_splide.on('dragging', function () {
    // Pause all videos while dragging
    video_splide.root.querySelectorAll('video').forEach(video => {
      video.pause();
    });
  });

  video_splide.on('dragged moved', function () {
    // Only play videos on mobile/tablet
    if (!isMobileOrTablet()) return; // ⛔ Exit early on desktop
    
    setTimeout(function(){
      video_splide.root.querySelectorAll('.splide__slide').forEach(slide => {
        const video = slide.querySelector('video');
        if (!video) return;

        const isActive =
          slide.classList.contains('is-active') &&
          slide.classList.contains('is-visible');

        if (isActive) {
          video.muted = true;
          video.playsInline = true;
          video.play().catch(() => {});
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    }, 1000);
  });

  function handleVideos(splide) {
    if (!isMobileOrTablet()) return; // ⛔ desktop exits early

    splide.root.querySelectorAll('.splide__slide').forEach(slide => {
      const video = slide.querySelector('video');
      if (!video) return;

      const isActive =
        slide.classList.contains('is-active') &&
        slide.classList.contains('is-visible');

      if (isActive) {
        video.muted = true;
        video.playsInline = true;

        if (video.paused) {
          video.play().catch(() => {});
        }
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  video_splide.on('mounted', () => {
    handleVideos(video_splide);
  });

  video_splide.on('moved', () => {
    handleVideos(video_splide);
  });

  window.addEventListener('resize', () => {
    if (!isMobileOrTablet()) {
      // Stop & reset all videos when leaving mobile/tablet
      video_splide.root.querySelectorAll('video').forEach(video => {
        video.pause();
        video.currentTime = 0;
      });
    } else {
      handleVideos(video_splide);
    }
  });

  window.addEventListener('load', () => {
    if (!isMobileOrTablet()) {
      // Stop & reset all videos on desktop
      video_splide.root.querySelectorAll('video').forEach(video => {
        video.pause();
        video.currentTime = 0;
      });
    } else {
      handleVideos(video_splide);
    }
  });
}
//Hover Mega Menu Open

// let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
//   console.log(items)
//     items.forEach(item => {
//       item.addEventListener("mouseover", () => {
//         item.setAttribute("open", true);
//         item.querySelector("summary").setAttribute("aria-expanded", true);
//         document.body.classList.add("mega_menu_open");
//         item.querySelector("ul").addEventListener("mouseleave", () => {
//           item.removeAttribute("open");
//           document.body.classList.remove("mega_menu_open");
//           item.querySelector("summary").setAttribute("aria-expanded", false);
//         });
//       item.addEventListener("mouseleave", () => {
//         item.removeAttribute("open");
//         document.body.classList.remove("mega_menu_open");
//         item.querySelector("summary").setAttribute("aria-expanded", false);
//       });
//     });
//   });

// Chat Icon click event
$(document).on('click','.main_chat_button .chat-message-icon', function(e){
  e.preventDefault();
    $(this).parents('.main_chat_button').addClass('active_message_icon');
});

$(document).on('click','.main_chat_button .chat-close-icon', function(e){
  e.preventDefault();
    $(this).parents('.main_chat_button').removeClass('active_message_icon');
});


// categories thumbnail 
  var swiper = new Swiper(".thumbnail_list", {
    slidesPerView: 1,
    spaceBetween: 48,
    scrollbar: {
      draggable: true,
      el: ".swiper-scrollbar"
    },
    breakpoints: {
      500: {
        slidesPerView: 2,
      },
      700: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
      1600: {
        slidesPerView: 5,
      },
    },
  });
  
// Feature Collection thumbnail
// var swiper = new Swiper(".feature_collection", {
//     slidesPerView: 1,
//     spaceBetween: 24,
//     scrollbar: {
//       draggable: true,
//       el: ".feature_scrollbar.swiper-scrollbar"
//     },
//     breakpoints: {
//       650: {
//         slidesPerView: 2,
//       },
//       1040: {
//         spaceBetween: 48,
//         slidesPerView: 3,
//       },
//     },
//   });

  // var swiper = new Swiper(".scroll-block", {
  //   slidesPerView: 2,
  //   spaceBetween: 0,
  //   scrollbar: {
  //     draggable: true,
  //     el: ".block_scrollbar.swiper-scrollbar"
  //   },
  //   breakpoints: {
  //     650: {
  //       slidesPerView: 2,
  //     },
  //     1040: {
  //       spaceBetween: 0,
  //       slidesPerView: 4,
  //     },
  //     1200: {
  //       spaceBetween: 0,
  //       slidesPerView: 4,
  //     },
  //     1400: {
  //       spaceBetween: 0,
  //       slidesPerView: 5,
  //     },
  //   },
  // });
// var swiper = new Swiper(".scroll-block", {
//   slidesPerView: "auto", // ✅ KEY FIX
//   spaceBetween: 0,
//   freeMode: false,
//   loop: true,
//   scrollbar: {
//     el: ".block_scrollbar.swiper-scrollbar",
//     draggable: true,
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   breakpoints: {
//     0: {
//       slidesPerView: "auto",
//     },
//   },
// });

// var swiper = new Swiper(".scroll-block", {
//   slidesPerView: "auto",
//   spaceBetween: 0,
//   freeMode: false,
//   loop: true,
//   loopAdditionalSlides: 2, // ✅ Prevents spacing gaps
//   loopedSlides: null, // ✅ Auto-calculate looped slides
//   centeredSlides: false, // ✅ Prevents centering issues
//   scrollbar: {
//     el: ".block_scrollbar.swiper-scrollbar",
//     draggable: true,
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   breakpoints: {
//     0: {
//       slidesPerView: "auto",
//     },
//   },
// });

var swiper = new Swiper(".scroll-block", {
  slidesPerView: 5,
  spaceBetween: 0,
  freeMode: false,
  loop: true,
  // CRITICAL FIX: Set loopedSlides to match the number of visible slides
  loopedSlides: 4, // Adjust this based on how many slides are visible at once
  // Alternative: Calculate dynamically
  // loopedSlides: document.querySelectorAll('.scroll-block .swiper-slide').length,
  loopAdditionalSlides: 3, // Increased for better buffering
  centeredSlides: false,
  // Add slideToClickedSlide if slides are clickable
  slideToClickedSlide: false,
  // Prevent issues with auto slidesPerView
  watchSlidesProgress: true,
  watchSlidesVisibility: true,
  scrollbar: {
    el: ".block_scrollbar.swiper-scrollbar",
    draggable: true,
    dragSize: 'auto', // Better scrollbar sizing
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: "auto",
      loopedSlides: 2, // Fewer slides on mobile
    },
    768: {
      slidesPerView: "auto",
      loopedSlides: 3,
    },
    1024: {
      slidesPerView: "auto",
      loopedSlides: 4,
    },
  },
  // Callbacks to handle edge cases
  on: {
    init: function() {
      // Ensure proper initialization
      this.update();
    },
    slideChange: function() {
      // Optional: Handle slide changes
    }
  }
});

var swiper = new Swiper(".scroll-block-video", {
  slidesPerView: "auto",
  spaceBetween: 0,
  freeMode: false,
  loop: true,
  // CRITICAL FIX: Set loopedSlides to match the number of visible slides
  loopedSlides: 4, // Adjust this based on how many slides are visible at once
  // Alternative: Calculate dynamically
  // loopedSlides: document.querySelectorAll('.scroll-block .swiper-slide').length,
  loopAdditionalSlides: 3, // Increased for better buffering
  centeredSlides: false,
  // Add slideToClickedSlide if slides are clickable
  slideToClickedSlide: false,
  // Prevent issues with auto slidesPerView
  watchSlidesProgress: true,
  watchSlidesVisibility: true,
  scrollbar: {
    el: ".block_scrollbar.swiper-scrollbar",
    draggable: true,
    dragSize: 'auto', // Better scrollbar sizing
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: "auto",
      loopedSlides: 2, // Fewer slides on mobile
    },
    768: {
      slidesPerView: "auto",
      loopedSlides: 3,
    },
    1024: {
      slidesPerView: "auto",
      loopedSlides: 4,
    },
  },
  // Callbacks to handle edge cases
  on: {
    init: function() {
      // Ensure proper initialization
      this.update();
    },
    slideChange: function() {
      // Optional: Handle slide changes
    }
  }
});


var swiper = new Swiper(".quick-add-modal__toggle .product__media-list", {
    slidesPerView: 1,
    spaceBetween: 24,
    scrollbar: {
      draggable: true,
      // el: ".travel-spray_scrollbar.swiper-scrollbar"
    },
    breakpoints: {
      650: {
        slidesPerView: 2,
      },
      1040: {
        spaceBetween: 48,
        slidesPerView: 3,
      },
    },
  });


  var swiper = new Swiper(".travel-spray-product-carousel", {
    slidesPerView: 1,
    spaceBetween: 24,
    scrollbar: {
      draggable: true,
      el: ".travel-spray_scrollbar.swiper-scrollbar"
    },
    breakpoints: {
      650: {
        slidesPerView: 2,
      },
      1040: {
        spaceBetween: 48,
        slidesPerView: 3,
      },
    },
  });

  var swiper = new Swiper(".travel-spray-product-carousel-popup", {
    slidesPerView: 1,
    spaceBetween: 24,
    scrollbar: {
      draggable: true,
      el: ".travel-spray-product-carousel-popup .travel-spray_scrollbar.swiper-scrollbar"
    },
    breakpoints: {
      650: {
        slidesPerView: 2,
      },
      1040: {
        spaceBetween: 24,
        slidesPerView: 3,
      },
    },
  });
window.addEventListener('resize', function(event){
  $('.mobile_media_gallery .main_media_gallery').slick('refresh');
  $('.mobile_media_gallery .thumbnail_media_gallery').slick('refresh');
});
  // product mobile slider
  $('.mobile_media_gallery .main_media_gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    fade: true,
    asNavFor: '.mobile_media_gallery .thumbnail_media_gallery'
  });
  $('.mobile_media_gallery .thumbnail_media_gallery').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.mobile_media_gallery .main_media_gallery',
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      }
    ]
  });
  
  if($('.banner-carousel .banner-slider .banner-slide').length > 1){  
    $('.banner-carousel .banner-slider').slick({
      dots: true,
      infinite: true,
      speed: 400,
      slidesToShow: 1,
      arrows: false,
      slidesToScroll: 1,
      adaptiveHeight: true
    });
  }


  $('.banner-slider .image_video').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 8000,
    asNavFor: '.banner-slider .banner_details'
  });
  $('.banner-slider .banner_details').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,    
    fade: true,
    autoplay: true,
    autoplaySpeed: 8000,
    cssEase: 'linear',
    asNavFor: '.banner-slider .image_video',    
    focusOnSelect: true
  });
  
  $(".feature-product-slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,    
    arrows: false,
    dots: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          centerMode: true,
          centerPadding: '60px',
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1200,
        settings: {
          centerMode: true,
          centerPadding: '60px',
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: '60px',
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: '60px',
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  $(".center-product-slider").slick({
    infinite: true,
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 4,    
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {                    
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {                    
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {                    
          slidesToShow: 1
        }
      }
    ]
  });

  setTimeout(function (){

    $(".fragrance-grid-list-scroll").slick({
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      arrows: false
    });
  },2000);
  
  $(".product-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
    ],
  });
  $(".video-slider-sec .video-row").slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
     responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".reviews-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });

  $(".image-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });
  
  // $(document).on('click','.accordion details',function(e) {
  //   e.preventDefault();
  //   if($(this).attr('open')){
  //    $(this).attr('open', false); 
  //   }else{
  //     $('.accordion details').attr('open', false);
  //     $(this).attr('open', true); 
  //   }
  // });
  
});
// Search box event change

$('.search__input').keyup(function () {
  if($(this).val().length === 0){
    $('.search__button').hide();
    $('.search_text_val').show();
  }else{
    $('.search__button').show();
    $('.search_text_val').hide();
  }
});

// sub_mega_menu open
$(".main_mega_menu button.mega_menu_sub").hover(function () {
//$(document).on('hover','.main_mega_menu button.mega_menu_sub',function(){
  var mega_menu_handle = $(this).data('handle');
  console.log(mega_menu_handle);
  $('.sub_mega_menu').removeClass('active');
  $('.single_menu li').removeClass('active');
  $('#'+mega_menu_handle).addClass('active');
  $(this).parent().addClass('active');
});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
$(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
// $("ul.tabs li").click(function() {
//   var parent = $(this).parents('.tab-container');

//   $(parent).find(".tab_content").hide();
//   var activeTab = $(this).attr("rel");
//   $(parent).find("#"+activeTab).fadeIn();

//   $(parent).find("ul.tabs li").removeClass("active");
//   $(this).addClass("active");

//   $(parent).find(".tab_drawer_heading").removeClass("d_active");
//   $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

// });
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");



// popup

$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');
  
      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });
  
  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });
  
  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
      var $modal = $(this);
      closeModal($modal);
  });
  
  function closeModal($modal) {
      $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
          $modal.removeClass('red green tan none');
          $modal.find('.sm_content').removeClass('red green tan');
          $modal.find('.sm_icon_menu').removeClass('is_right is_left');
          $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
      }, 400);
  }

  $(document).on('click', '.announcement-bar .close_button', function() {
    createCookie("announcement-bar-popup", "closed", 1);
    $('.announcement-bar-section').hide();
  });
  if (readCookie('announcement-bar-popup') == "closed") {
     $('.announcement-bar-section').hide();
  }  
});

function createCookie(name, value, days) {
  var expires;
  
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}
function readCookie(name) {
  var nameEQ = encodeURIComponent(name) + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ')
        c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0)
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}
$(document).ready(function(){ 
    $('.tab').click(function(){  
        // Remove the 'tab-active' class from all tab contents
        $(".tab-contains").removeClass('tab-active');

        // Add the 'tab-active' class to the tab content that matches the clicked tab's data-id
        $(".tab-contains[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");

        // Remove the 'active' class from all tabs
        $(".tab").removeClass('active');

        // Add the 'active' class to the clicked tab
        $(this).addClass('active');
    });  
});

$(window).scroll(function() { 
    var scroll = $(window).scrollTop();
    var windowHeight = $('#shopify-section-text-image-animation').height();
    if(windowHeight != undefined){
      var InnerHight = $('#shopify-section-text-image-animation').offset().top + 150;
      var overviewScrollTop = InnerHight - $(window).scrollTop();
  
      if (windowHeight > overviewScrollTop) {
        $(".text-image-animation .flex-box.aos-init").addClass("animation-start");
      }else{
        $(".text-image-animation .flex-box.aos-init").removeClass("animation-start");
      }
    }
});

// UTM parameters
document.addEventListener("DOMContentLoaded", function () {
  // Function to get UTM parameters
  function getUTMParameters() {
    const params = new URLSearchParams(window.location.search);
    const utmParams = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((key) => {
      if (params.has(key)) {
        utmParams[key] = params.get(key);
      }
    });
    return utmParams;
  }

  // Function to append UTM parameters to a specific link
  function appendUTMToLink(link, utmParams) {
    if (!link || Object.keys(utmParams).length === 0) return;
    const url = new URL(link.href, window.location.origin);
    for (const [key, value] of Object.entries(utmParams)) {
      url.searchParams.set(key, value);
    }
    link.href = url.toString();
  }

  // Persist UTM parameters in the current URL
  function persistUTMInURL(utmParams) {
    if (Object.keys(utmParams).length > 0) {
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of Object.entries(utmParams)) {
        currentUrl.searchParams.set(key, value);
      }
      window.history.replaceState({}, document.title, currentUrl.toString());
    }
  }

  // Update all links with UTM parameters
  function updateLinks(utmParams) {
    const links = document.querySelectorAll('a[href^="/"], a[href^="' + window.location.origin + '"]');
    links.forEach((link) => appendUTMToLink(link, utmParams));
  }

  // Update the "Go to bag" link in the cart drawer
  function updateCartDrawerLink(utmParams) {
    const cartDrawerLink = document.querySelector('a[href="/cart"]'); // Adjust selector if needed
    appendUTMToLink(cartDrawerLink, utmParams);
  }

  // Update the "Back to shopping" button when the cart is empty
  function updateBackToShoppingButton(utmParams) {
    const backToShoppingButton = document.querySelector('a.button_custom[href="/collections/all-fragrances"]'); // Exact selector for "Back to shopping" button
    appendUTMToLink(backToShoppingButton, utmParams);
  }

  // Observe cart updates and dynamically update the "Go to bag" and "Back to shopping" links
  function observeCartUpdates(utmParams) {
    const cartDrawer = document.querySelector('#CartDrawer'); // Adjust selector if needed
    if (!cartDrawer) return;

    // MutationObserver to detect when the cart drawer is updated
    const observer = new MutationObserver(() => {
      updateCartDrawerLink(utmParams);
      updateBackToShoppingButton(utmParams);
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }

  // Initialize
  const utmParams = getUTMParameters();
  persistUTMInURL(utmParams); // Persist UTM in the current URL
  updateLinks(utmParams); // Update all internal links with UTM parameters
  updateCartDrawerLink(utmParams); // Update the "Go to bag" link
  updateBackToShoppingButton(utmParams); // Update the "Back to shopping" button
  observeCartUpdates(utmParams); // Observe cart drawer updates
});

/* Klarna messaging */
/* Home */
document.addEventListener('DOMContentLoaded', () => {
  const TARGET_SELECTORS = [
    'div.loaded.default.homepage-promotion-wide',
    'div.loaded.default.homepage-promotion-box'
  ];

  function applyStylesInRoot(root) {
    let appliedCount = 0;

    TARGET_SELECTORS.forEach(sel => {
      const nodes = root.querySelectorAll(sel);
      nodes.forEach(el => {
        el.style.setProperty('display', 'block', 'important');
        el.style.setProperty('margin', 'auto', 'important');
        appliedCount += 1;
        console.log(`Styles applied to ${sel}`);
      });
    });

    return appliedCount;
  }

  function observeShadowRoot(shadowRoot) {
    // Try immediately
    let count = applyStylesInRoot(shadowRoot);
    if (count > 0) return;

    // Observe future mutations inside the shadow root
    const shadowObserver = new MutationObserver(() => {
      const appliedNow = applyStylesInRoot(shadowRoot);
      if (appliedNow > 0) {
        shadowObserver.disconnect();
      }
    });

    shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
  }

  function handlePlacement(el) {
    if (!el) return;
    // If the element already has an open shadow root, use it
    if (el.shadowRoot) {
      observeShadowRoot(el.shadowRoot);
    } else {
      // Watch for shadow root or children being attached later
      const ro = new MutationObserver(() => {
        if (el.shadowRoot) {
          ro.disconnect();
          observeShadowRoot(el.shadowRoot);
        }
      });
      ro.observe(el, { childList: true, subtree: true });
    }
  }

  // Process any existing placements
  document.querySelectorAll('klarna-placement').forEach(handlePlacement);

  // Also watch for placements added later
  const docObserver = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.matches && node.matches('klarna-placement')) {
            handlePlacement(node);
          }
          node.querySelectorAll?.('klarna-placement').forEach(handlePlacement);
        }
      });
    });
  });

  docObserver.observe(document.body, { childList: true, subtree: true });
});


// desktop PDP handle video play n pause 
document.addEventListener('DOMContentLoaded', function () {
  const playBtn = document.querySelector('.video-play-button');
  const videoContainer = document.querySelector('#videoPopupplay');
  const videoPlayBox = document.querySelector('.video_play_box');
  const mainVideo = videoContainer ? videoContainer.querySelector('video') : null;

  if (!playBtn || !videoContainer) {
    console.warn('Play button or video container not found');
    return;
  }

  playBtn.addEventListener('click', function () {
    videoContainer.classList.remove('hidden');
    videoPlayBox.classList.add('hidden');
    if (mainVideo) mainVideo.play();
  });

  if (mainVideo) {
    mainVideo.addEventListener('pause', function () {
      console.log('Video paused');
      // Do any action you want when paused
      videoContainer.classList.add('hidden');
      videoPlayBox.classList.remove('hidden');
    });
  }
});

// mobile PDP handle video play n pause 
document.addEventListener('DOMContentLoaded', function () {
  const mplayBtn = document.querySelector('.mvideo-play-button');
  const mvideoContainer = document.querySelector('#mvideoPopupplay');
  const mvideoPlayBox = document.querySelector('.mvideo_play_box');
  const mobmainVideo = mvideoContainer ? mvideoContainer.querySelector('video') : null;

  if (!mplayBtn || !mvideoContainer) {
    console.warn('Play button or video container not found');
    return;
  }

  mplayBtn.addEventListener('click', function () {
    mvideoContainer.classList.remove('hidden');
    mvideoPlayBox.classList.add('hidden');
    if (mobmainVideo) mobmainVideo.play();
  });

  if (mobmainVideo) {
    mobmainVideo.addEventListener('pause', function () {
      console.log('Video paused');
      // Do any action you want when paused
      mvideoContainer.classList.add('hidden');
      mvideoPlayBox.classList.remove('hidden');
    });
  }
});

// megamenu on hover

document.addEventListener("DOMContentLoaded", () => {
  const megaMenus = document.querySelectorAll("details.mega-menu");

  megaMenus.forEach(details => {
    let hoverTimeout;

    details.addEventListener("mouseenter", () => {
      clearTimeout(hoverTimeout);
      details.setAttribute("open", "");
    });

    details.addEventListener("mouseleave", () => {
      hoverTimeout = setTimeout(() => {
        details.removeAttribute("open");
      }, 150);
    });
  });
});

// new quickview btn click
let newQuickViewaBtns = document.querySelectorAll(".js-pro-cart-button");
newQuickViewaBtns.forEach((newQuickViewaBtn) => {
  newQuickViewaBtn.addEventListener("click",(e)=>{
    let quickViewDiv = e.target.closest(".card--standard").querySelector(".quick-add").querySelector(".quick-add__submit");
    // console.log(quickViewDiv)
    quickViewDiv.click();
  })
})

let productTitleBtns = document.querySelectorAll(".js-open-qiock-view")

productTitleBtns.forEach(btn => {
  btn.addEventListener('click', function(e) {
    e.preventDefault(); // Prevent default action if needed
    
    // Find the closest parent with class 'product-card-wrapper'
    let productCard = this.closest('.product-card-wrapper');
    
    // Find the cart button within that parent
    if (productCard) {
      let cartButton = productCard.querySelector('.js-pro-cart-button');
      
      // Click the cart button if it exists
      if (cartButton) {
        cartButton.click();
      }
    }
  });
});

// read more and read less functionality

document.addEventListener('DOMContentLoaded', () => {
  const truncate = document.querySelectorAll('.description-truncate');
  const full = document.querySelectorAll('.description-full');
  const buttons = document.querySelectorAll('.read-more-btn');

  if (!truncate.length > 0 || !full.length > 0 || !buttons.length > 0) return;
  buttons.forEach((button) => {

    button.addEventListener('click', (e) => {
      const expanded = button.getAttribute('aria-expanded') === 'true';

      e.target.closest(".product-main-description").querySelector('.description-truncate').classList.toggle('hidden', !expanded);
       e.target.closest(".product-main-description").querySelector('.description-full').classList.toggle('hidden', expanded);

      button.textContent = expanded ? 'Read more' : 'Read less';
      button.setAttribute('aria-expanded', String(!expanded));
    });
  })
});



 document.addEventListener("DOMContentLoaded", function () {
    const warning = document.querySelectorAll(".cart-warning");
    const closeBtns = document.querySelectorAll(".close-btn");
    closeBtns.forEach((closeBtn) => {

      closeBtn.addEventListener("click", function (e) {
        e.target.closest(".cart-warning").style.display = "none";
      });
    })
  });

  document.addEventListener("DOMContentLoaded", function () {
  const heroSection = document.querySelector(".collection-hero-text");
  if (!heroSection) return;

  const body = document.body;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Hero is visible → remove sticky
          body.classList.remove("sticky-filter");
        } else {
          // Hero is NOT visible → add sticky
          body.classList.add("sticky-filter");
        }
      });
    },
    {
      root: null,
      threshold: 0,
    }
  );

  observer.observe(heroSection);
});




// video section hover event

// document.addEventListener("mouseover", (e) => {
//   const video = e.target.closest(".js-video-sec .video-wrapper video");
//   if (video && !video.paused) {
//     video.pause();
//   }
// });

// document.addEventListener("mouseout", (e) => {
//   const video = e.target.closest(".js-video-sec .video-wrapper video");
//   if (video && video.paused) {
//     video.play().catch(() => {});
//   }
// });

document.addEventListener("mouseover", (e) => {
  const wrapper = e.target.closest(".js-video-sec");
  console.log(wrapper)
  if (!wrapper) return;

  const video = wrapper.querySelector("video");
  console.log(video)
  if (video && video.paused) {
    video.play();
  }
});

document.addEventListener("mouseout", (e) => {
  const wrapper = e.target.closest(".js-video-sec");
  if (!wrapper) return;

  const video = wrapper.querySelector("video");
  if (video && !video.paused) {
    video.pause().catch(() => {});
  }
});


document.addEventListener('DOMContentLoaded', function () {

  const openerSelector = '.product__modal-opener';

  function initModalGallery() {
    const $main = $('.main_banner_media');
    const $thumbs = $('.thumbnail_media_gallery');

    if (!$main.length || !$thumbs.length) return;

    // 🔒 Prevent re-initialization
    if (!$thumbs.hasClass('slick-initialized')) {
      $thumbs.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.main_banner_media',
        vertical: true,
        verticalSwiping: true,
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,

        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              vertical: false,
              verticalSwiping: false
            }
          }
        ]
      });
    }

    if (!$main.hasClass('slick-initialized')) {
      $main.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        fade: false,
        asNavFor: '.thumbnail_media_gallery'
      });
    }

    // 🔁 IMPORTANT: Fix layout & active slide
    setTimeout(() => {
      $thumbs.slick('setPosition');
      $main.slick('setPosition');
    }, 50);
  }

  // 🚀 Init on modal opener click
  document.addEventListener('click', function (e) {
    if (e.target.closest(openerSelector)) {
      console.log('openerSelector ', openerSelector)
      initModalGallery();
    }
  });

});


	
document.addEventListener('click', function (e) {

  const zoomIn = e.target.closest('.zoom_dialog_button.zoom_in');
  const zoomOut = e.target.closest('.zoom_dialog_button.zoom_out');

  if (!zoomIn && !zoomOut) return;

  // Active zoom target = IMAGE inside active slick slide
  const target = document.querySelector(
    '.main_banner_media .slick-slide.slick-current.slick-active'
  );

  if (!target) {
    console.warn('Zoom target image not found');
    return;
  }

  let zoom = parseFloat(target.dataset.zoom || 1);

  if (zoomIn) {
    zoom = Math.min(2, zoom + 0.1); // max 200%
  }

  if (zoomOut) {
    zoom = Math.max(1, zoom - 0.1); // min 100%
  }

  zoomInOut(target, zoom)

  const zoomedPercentage = Math.round(zoom * 100) - 100;
  const showZoomedNum = document.querySelector('.zoomed_value');
  showZoomedNum.innerHTML = zoomedPercentage;

  const navArrows = document.querySelectorAll('.thumbnail_media_gallery .slick-arrow');
  navArrows.forEach(navArrow => {
    navArrow.addEventListener('click', function() {
      showZoomedNum.innerHTML = 0;
      zoomInOut(target, 1)
    });
  });

  const thumbImgs = document.querySelectorAll('.thumbnail_media_gallery img.global-media-settings');
  thumbImgs.forEach(thumbImg => {
    thumbImg.addEventListener('click', function() {
      showZoomedNum.innerHTML = 0;
      zoomInOut(target, 1)
    });
  });

  function zoomInOut(target, zoom) {
    target.style.transform = `scale(${zoom})`;
    target.style.transformOrigin = 'center center';
    target.dataset.zoom = zoom;
  }
});

// country dropdown code start

(function() {

  // Ensure window variables are available
  if (!window.shopifyCartData || !window.shippingConfig) {
    console.error('Shipping configuration not loaded');
    return;
  }

  const { rates, countryGroups } = window.shippingConfig;
  let { cartTotal, currency, currencySymbol } = window.shopifyCartData;

  // Currency symbol mapping
  const currencySymbolMap = {
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'SAR': 'ر.س',
    'AED': 'د.إ'
  };

  // Get currency from cart_currency cookie
  function getCurrencyFromCookie() {
    try {
      const cookies = document.cookie.split(';');
      for (let c of cookies) {
        const [name, value] = c.trim().split('=');
        if (name === 'cart_currency') {
          const cookieCurrency = decodeURIComponent(value).trim();
          if (cookieCurrency) {
            return {
              currency: cookieCurrency,
              symbol: currencySymbolMap[cookieCurrency] || cookieCurrency
            };
          }
        }
      }
    } catch (e) {
      console.error('Currency cookie parse error', e);
    }
    return null;
  }

  // Update currency from cookie if available
  const cookieCurrency = getCurrencyFromCookie();
  if (cookieCurrency) {
    currency = cookieCurrency.currency;
    currencySymbol = cookieCurrency.symbol;
  }

  let globalSelectedCountry = null;

  function parseLocalizationCookie(rawValue) {
    try {
      const decoded = decodeURIComponent(rawValue);

      // Case 1: JSON format
      if (decoded.startsWith('{')) {
        const parsed = JSON.parse(decoded);
        if (parsed && parsed.country) {
          return parsed.country;
        }
      }

      // Case 2: Plain country code (e.g. "DE")
      if (/^[A-Z]{2}$/.test(decoded)) {
        return decoded;
      }
    } catch (e) {
      console.error('Localization parse error', e);
    }

    return null;
  }

  // Dynamic country code mapping - build from all country groups
  function buildCountryCodeMapping() {
    const mapping = {};
    
    // Map country codes to country names dynamically
    const allMappings = {
      // Arab countries
      AE: 'Saudi Arabia',
      SA: 'Saudi Arabia',
      BH: 'Bahrain',
      IQ: 'Iraq',
      KW: 'Kuwait',
      OM: 'Oman',
      QA: 'Qatar',
      // Free shipping countries (EU + UK + USA)
      GB: 'UK',
      US: 'USA',
      AT: 'Austria',
      BE: 'Belgium',
      BG: 'Bulgaria',
      HR: 'Croatia',
      CZ: 'Czechia',
      DE: 'Germany',
      DK: 'Denmark',
      EE: 'Estonia',
      FR: 'France',
      GR: 'Greece',
      HU: 'Hungary',
      IT: 'Italy',
      LV: 'Latvia',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      NL: 'Netherlands',
      PL: 'Poland',
      PT: 'Portugal',
      RO: 'Romania',
      SK: 'Slovakia',
      SI: 'Slovenia',
      ES: 'Spain',
      SE: 'Sweden',
      // Other countries
      AU: 'Australia',
      CA: 'Canada',
      CY: 'Cyprus',
      FI: 'Finland',
      HK: 'Hong Kong',
      IE: 'Ireland',
      IL: 'Israel',
      JP: 'Japan',
      JE: 'Jersey',
      KE: 'Kenya',
      MY: 'Malaysia',
      MT: 'Malta',
      NZ: 'New Zealand',
      NO: 'Norway',
      PK: 'Pakistan',
      SG: 'Singapore',
      ZA: 'South Africa',
      KR: 'South Korea',
      CH: 'Switzerland'
    };

    // Only include mappings for countries that exist in our country groups
    const allCountries = [
      ...(countryGroups.freeShipping || []),
      ...(countryGroups.arabCountries || []),
      ...(countryGroups.otherCountries || [])
    ];

    Object.keys(allMappings).forEach(code => {
      const countryName = allMappings[code];
      const exists = allCountries.some(c => 
        c.trim().toLowerCase() === countryName.toLowerCase()
      );
      if (exists) {
        mapping[code] = countryName;
      }
    });

    return mapping;
  }

  const countryCodeMapping = buildCountryCodeMapping();

  function getCountryType(country) {
    const normalized = country.trim().toLowerCase();

    if (countryGroups.freeShipping && countryGroups.freeShipping.some(c => c.trim().toLowerCase() === normalized)) {
      return 'freeShipping';
    }
    if (countryGroups.arabCountries && countryGroups.arabCountries.some(c => c.trim().toLowerCase() === normalized)) {
      return 'arabCountry';
    }
    if (countryGroups.otherCountries && countryGroups.otherCountries.some(c => c.trim().toLowerCase() === normalized)) {
      return 'otherCountry';
    }
    return 'otherCountry'; // Default to other country
  }

  function isValidCountry(country) {
    const allCountries = [
      ...(countryGroups.freeShipping || []),
      ...(countryGroups.arabCountries || []),
      ...(countryGroups.otherCountries || [])
    ];
    return allCountries.some(c => c.trim().toLowerCase() === country.trim().toLowerCase());
  }

  function saveToLocalStorage(country) {
    try {
      localStorage.setItem('selectedCountry', country);
      localStorage.setItem('selectedCountryType', getCountryType(country));
      localStorage.setItem('selectedCountryTimestamp', Date.now().toString());
    } catch (e) {
      console.error(e);
    }
  }

  function getFromLocalStorage() {
    try {
      const country = localStorage.getItem('selectedCountry');
      if (country && isValidCountry(country)) {
        return { country };
      }
    } catch (e) {}
    return { country: null };
  }

  function clearLocalStorage() {
    localStorage.removeItem('selectedCountry');
    localStorage.removeItem('selectedCountryType');
    localStorage.removeItem('selectedCountryTimestamp');
  }

  function checkLocalizationCookie() {
    try {
      const cookies = document.cookie.split(';');
      const allCountries = [
        ...(countryGroups.freeShipping || []),
        ...(countryGroups.arabCountries || []),
        ...(countryGroups.otherCountries || [])
      ];

      for (let c of cookies) {
        const [name, value] = c.trim().split('=');
        if (name === 'localization') {
          const code = parseLocalizationCookie(value);
          if (!code) return null;

          // Check if we have a mapping for this code
          if (countryCodeMapping[code]) {
            return countryCodeMapping[code];
          }

          // Check for direct match
          const directMatch = allCountries.find(c =>
            c.toLowerCase() === code.toLowerCase()
          );
          if (directMatch) return directMatch;

          // If code doesn't match, default to first country in otherCountries
          if (countryGroups.otherCountries && countryGroups.otherCountries.length > 0) {
            return countryGroups.otherCountries[0];
          }

          return null;
        }
      }
    } catch (e) {
      console.error(e);
    }
    return null;
  }

  // Localization resolver (authoritative)
  function resolveCountryFromLocalization() {
    try {
      const cookies = document.cookie.split(';');
      for (let c of cookies) {
        const [name, value] = c.trim().split('=');
        if (name === 'localization') {
          const code = parseLocalizationCookie(value);
          
          if (!code) {
            // Default to first country in otherCountries if available
            if (countryGroups.otherCountries && countryGroups.otherCountries.length > 0) {
              return countryGroups.otherCountries[0];
            }
            return null;
          }

          // Rule 1: Check if we have a mapping for this code
          if (countryCodeMapping[code]) {
            return countryCodeMapping[code];
          }

          // Rule 2: If not mapped, default to first country in otherCountries
          if (countryGroups.otherCountries && countryGroups.otherCountries.length > 0) {
            return countryGroups.otherCountries[0];
          }
        }
      }
    } catch (e) {
      console.error('Localization resolve error', e);
    }
    
    // Final fallback: first country in otherCountries
    if (countryGroups.otherCountries && countryGroups.otherCountries.length > 0) {
      return countryGroups.otherCountries[0];
    }
    return null;
  }

  // Resolve localization ONCE on page load
  if (!globalSelectedCountry) {
    globalSelectedCountry = resolveCountryFromLocalization();
    if (globalSelectedCountry) {
      saveToLocalStorage(globalSelectedCountry);
    }
  }

  /* ============================ */

  function formatMoney(amount) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2
      }).format(amount);
    } catch {
      return `${currencySymbol}${amount.toFixed(2)}`;
    }
  }

  function getShippingMessage(country) {
    const type = getCountryType(country);
    const total = parseFloat(cartTotal) || 0;

    const icon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#25A249" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      `;

    if (type === 'freeShipping') {
      return { type: 'free', message: 'Free shipping available!', icon, progressPercentage: 100, currentAmount: 0, targetAmount: 0 };
    }

    if (type === 'arabCountry') {
      if (total >= rates.arabMinCart) {
        return { type: 'free', message: 'Free shipping unlocked!', icon, progressPercentage: 100, currentAmount: total, targetAmount: rates.arabMinCart };
      }
      const progressPercentage = (total / rates.arabMinCart) * 100;
      return {
        type: 'paid',
        message: `You're ${formatMoney(rates.arabMinCart - total)} away from FREE shipping!`,
        progressPercentage,
        currentAmount: total,
        targetAmount: rates.arabMinCart
      };
    }

    // otherCountry
    if (total >= rates.otherMinCart) {
      return { type: 'free', message: 'Free shipping unlocked!', icon, progressPercentage: 100, currentAmount: total, targetAmount: rates.otherMinCart };
    }

    const progressPercentage = (total / rates.otherMinCart) * 100;
    return {
      type: 'paid',
      message: `You're ${formatMoney(rates.otherMinCart - total)} away from FREE shipping!`,
      progressPercentage,
      currentAmount: total,
      targetAmount: rates.otherMinCart
    };
  }

  // function showShippingMessageGlobal(country) {
  //   document.querySelectorAll('.shipping-notification').forEach(e => e.remove());

  //   const info = getShippingMessage(country);
  //   document.querySelectorAll('.region-disclosure').forEach(dropdown => {
  //     const msg = document.createElement('div');
  //     msg.className = `shipping-notification shipping-notification--${info.type} shipping-notification__text`;
      
  //     // Build the progress bar HTML
  //     let progressBarHTML = '';
  //     if (info.type === 'paid') {
  //       progressBarHTML = `
  //         <div class="shipping-progress-bar" style="width: 100%; height: 8px; background-color: #F7EFE5; border-radius: 4px; margin-top: 8px; overflow: hidden;">
  //           <div class="shipping-progress-fill" style="width: ${info.progressPercentage}%; height: 100%; display:block; background-color: #705938; border-radius: 4px; transition: width 0.3s ease;"></div>
  //         </div>
  //       `;
  //     } else if (info.type === 'free') {
  //       progressBarHTML = `
  //         <div class="shipping-progress-bar" style="width: 100%; height: 8px; background-color: #F7EFE5; border-radius: 4px; margin-top: 8px; overflow: hidden;">
  //           <div class="shipping-progress-fill" style="width: 100%; height: 100%; background-color: #705938; display:block; border-radius: 4px; transition: width 0.3s ease;"></div>
  //         </div>
  //       `;
  //     }
      
  //     msg.innerHTML = `
  //       <div class="shipping-notification__content">${info.icon || ''}${info.message}</div>
  //       ${progressBarHTML}
  //     `;
  //     dropdown.parentNode.insertBefore(msg, dropdown);
  //   });
  // }
  function showShippingMessageGlobal(country) {
    document.querySelectorAll('.shipping-notification').forEach(e => e.remove());

    const info = getShippingMessage(country);
    
    document.querySelectorAll('.region-disclosure').forEach(dropdown => {
      const msg = document.createElement('div');
      
      // Add free-shipping-unlock class for all free shipping scenarios
      const freeShippingClass = info.type === 'free' ? ' free-shipping-unlock' : '';
      msg.className = `shipping-notification shipping-notification--${info.type} shipping-notification__text${freeShippingClass}`;
      
      // Build the progress bar HTML - only for paid shipping
      let progressBarHTML = '';
      if (info.type === 'paid') {
        progressBarHTML = `
          <div class="shipping-progress-bar" style="width: 100%; height: 8px; background-color: #F7EFE5; border-radius: 4px; margin-top: 8px; overflow: hidden;">
            <div class="shipping-progress-fill" style="width: ${info.progressPercentage}%; height: 100%; display:block; background-color: #705938; border-radius: 4px; transition: width 0.3s ease;"></div>
          </div>
        `;
      }
      // No progress bar for free shipping (info.type === 'free')
      
      msg.innerHTML = `
        <div class="shipping-notification__content">${info.icon || ''}${info.message}</div>
        ${progressBarHTML}
      `;
      dropdown.parentNode.insertBefore(msg, dropdown);
    });
  }

  class CountryDropdown {
    constructor(el, index) {
      this.element = el;
      this.index = index;
      this.trigger = el.querySelector('.region-disclosure__trigger');
      this.wrapper = el.querySelector('.region-disclosure__wrapper');
      this.regionLinks = el.querySelectorAll('.region-disclosure__link');
      this.selectedText = el.querySelector('.region-selected-text');
      this.init();
    }

    clearAllSelections() {
      this.regionLinks.forEach(link => {
        link.classList.remove('region-selected');
        link.removeAttribute('aria-current');
        link.querySelectorAll('svg, .checkmark, .visibility-hidden')
          .forEach(el => el.classList.add('visibility-hidden'));
      });
    }

    markSelectedCountry(country) {
      this.clearAllSelections();
      this.selectedText.textContent = country;

      this.regionLinks.forEach(link => {
        if (link.dataset.region?.toLowerCase() === country.toLowerCase()) {
          link.classList.add('region-selected');
          link.setAttribute('aria-current', 'true');
          link.querySelectorAll('svg, .checkmark, .visibility-hidden')
            .forEach(el => el.classList.remove('visibility-hidden'));
        }
      });
    }

    updateSelectedCountry(country) {
      if (globalSelectedCountry === country) return;
      globalSelectedCountry = country;
      saveToLocalStorage(country);
      updateAllDropdowns(country);
      showShippingMessageGlobal(country);
    }

    init() {
      // First load localization fix
      if (globalSelectedCountry) {
        this.markSelectedCountry(globalSelectedCountry);
        showShippingMessageGlobal(globalSelectedCountry);
      }

      this.trigger.addEventListener('click', e => {
        e.preventDefault();
        closeAllDropdowns(this.index);
        this.wrapper.hidden = !this.wrapper.hidden;
      });

      this.regionLinks.forEach(link => {
        link.addEventListener('click', e => {
          e.preventDefault();
          this.updateSelectedCountry(link.dataset.region);
          this.wrapper.hidden = true;
        });
      });

      // Check stored or localization cookie
      const stored = getFromLocalStorage().country || checkLocalizationCookie();
      if (stored && isValidCountry(stored)) {
        globalSelectedCountry = stored;
        this.markSelectedCountry(stored);
        showShippingMessageGlobal(stored);
      }
    }
  }

  let dropdownInstances = [];

  function updateAllDropdowns(country) {
    dropdownInstances.forEach(d => d.markSelectedCountry(country));
  }

  document.addEventListener('click', function (e) {
    dropdownInstances.forEach(dropdown => {
      if (!dropdown.element.contains(e.target)) {
        dropdown.wrapper.hidden = true;
      }
    });
  });

  function closeAllDropdowns(except = -1) {
    dropdownInstances.forEach((d, i) => {
      if (i !== except) d.wrapper.hidden = true;
    });
  }

  function initializeAllDropdowns() {
    dropdownInstances = [];
    document.querySelectorAll('.region-disclosure').forEach((el, i) => {
      dropdownInstances.push(new CountryDropdown(el, i));
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initializeAllDropdowns();
  });

})();

// country dropdown code end